'use strict';

const libPictView = require('pict-view');
const libProjectEditWorkspace = require('./ProjectEditWorkspace.js');

// Small additions on top of the reused .pew-* form styles: the required mark, and the inline notes that report
// the resolved project and the packet size (the two things a user cannot see but needs to know before saving).
const ICW_CSS = /*css*/`
	.icw-req { color: var(--theme-color-status-error, #cf5b5b); font-weight: 700; }
	.icw-note { display: block; margin-top: 0.35rem; font-size: 0.78rem; line-height: 1.35; color: var(--theme-color-text-muted, #6b7686); }
	.icw-note-ok { color: var(--theme-color-status-success, #3a8a63); }
	.icw-note-bad { color: var(--theme-color-status-error, #cf5b5b); }
	.icw-project { min-height: 1.1rem; }
`;

/**
 * InspectionCreateWorkspace — the bespoke Inspection CREATE screen, reached by the app-router Create bridge on
 * #/PSRS/Inspection/Create (which shadows the generic record-set create form).
 *
 * A thin shell: all data, behavior and hand-built form HTML live in the InspectionCreateWorkspace provider,
 * which assigns into the #ICW-Body mount. Reuses the Edit workspace's .pew-* CSS.
 */
class InspectionCreateWorkspace extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pict;
	}

	get provider() { return this.pict.providers.InspectionCreateWorkspace; }

	onAfterRender(pRenderable)
	{
		this.pict.CSSMap.injectCSS();
		const tmpProvider = this.provider;
		if (tmpProvider) { tmpProvider.render(); }
		return super.onAfterRender(pRenderable);
	}
}

module.exports = InspectionCreateWorkspace;

module.exports.default_configuration =
{
	ViewIdentifier: 'InspectionCreateWorkspace',
	DefaultRenderable: 'InspectionCreateWorkspaceWrap',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,
	CSS: libProjectEditWorkspace.default_configuration.CSS + ICW_CSS,
	Templates:
	[
		{
			Hash: 'InspectionCreateWorkspace-Wrap',
			Template: /*html*/`<div class="pew-wrap"><div id="ICW-Body"></div></div>`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'InspectionCreateWorkspaceWrap',
			TemplateHash: 'InspectionCreateWorkspace-Wrap',
			DestinationAddress: '#PlatformConfiguration-Application-Container',
			RenderMethod: 'replace',
		},
	],
};
